import { Text, TextType } from 'ui-components/components/text';

import { messages } from '../automation-tools/messages';

import style from './tool-activity-pill.module.less';

type ToolActivityPillProps = {
  isSetup: boolean;
};

export const ToolActivityPill = ({ isSetup }: ToolActivityPillProps) => {
  if (isSetup) return null;

  return <Text className={style['activity-pill']} textType={TextType.Caption} value={messages.inactive} />;
};
